/* eslint-disable unicorn/prefer-module */
/* eslint-disable no-console */
import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { VentasMiListaClientes } from "../../components";
import { useAuthContext } from "../../context/auth";
import "./stylesVentasEjecutivo.scss";

const VentasEjecutivo = () => {
  const { pais } = useAuthContext() || {};
  const navigate = useNavigate();

  const logo = useMemo(
    () =>
      ({
        Chile: require("../../img/wecast-logo.png"),
        Perú: require("../../img/visiona-logo.png"),
        Uruguay: require("../../img/screenmedia-logo.png"),
        Region: require("../../img/adigital-logo.png"),
      })[pais] || require("../../img/visiona-logo.png"),
    [pais]
  );

  return (
    <div>
      <div className="ventas-ejecutivo">
        <div className="logo-container">
          <img src={logo} alt={`${pais} Logo`} className="logo" onClick={() => navigate("/admin")} />
        </div>
        <VentasMiListaClientes />
      </div>
    </div>
  );
};

export default VentasEjecutivo;
